import { size , includes} from "lodash";
import { QuestionType } from "./DragAndDropRunner";
export default function QuizWarnings(data,answers) {
  let answeredQuestion = [];
  let notAnswered = [];
  let ans = [];
  let fields;
  answers &&
    answers.forEach((answer) => {
      let selectdAnswers = [];
      answeredQuestion.push(answer.question_id);
      answer &&
        answer.selected_answers &&
        answer.selected_answers.forEach((sel_answer) => {
          selectdAnswers.push(sel_answer.answer);
        });
      ans.push({ question_id: answer.question_id, selectdAnswers });
    });

  data &&
    data.questions &&
    data.questions.forEach((question, i) => {
      let noOfFilelds = [];
      if (includes(answeredQuestion, question.id) === false) {
        notAnswered.push(i + 1);
      } else {
        if (
          question.type === "FillInBlankChoices" ||
          question.type === "FillInBlank" ||
          includes(question.type, "Drag")
        ) {
          question.prompt_content.replace(
            /\[\[[^\]]*\]\]/g,
            function replacer(matched) {
              let fieldNumber = `${matched.match(/\d+/)}`;
              noOfFilelds.push(fieldNumber);
            }
          );
          fields = size(noOfFilelds);
          if (question.type === QuestionType.DragAndDropFillinQuestion || question.type === QuestionType.DragAndDropOptionsMisleading) {
            fields -= 1;
          }

          ans.forEach((sel) => {
            if (sel.question_id === question.id) {
              if (parseInt(fields) !== size(sel.selectdAnswers)) {
                notAnswered.push(i + 1);
              }
            }
          });
        }
      }
    });
  return notAnswered;
}
